/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from './app.core.module.js';
import login from './login/login.module.js';
import logout from './logout/logout.module.js';
import errorpage from './errorpage/errorpage.module.js';
import infopage from './infopage/infopage.module.js';
import account from './login/account/account.module.js';
import forgotten from './login/forgotten/forgotten.module.js';
import memword from './login/memword/memword.module.js';
import termscond from './login/termscond/termscond.module.js';
import establishMemword from './login/establishmemword/establishmemword.module.js';
import registration from './login/registration/registration.module.js';
import twofactor from './login/2fa/2fa.module.js';
import securityquestion from './login/securityquestion/securityquestion.module';
import changepassword from './login/changepassword/changepassword.module.js';
import changeforgottenpassword from './login/changeforgottenpassword/changeforgottenpassword.module.js';
// Import all commonly used directives
import autofocus from './login/autofocus.js';
import clickOrEnter from './login/click-or-enter.js';
import myOnLoad from './logout/my-on-load.js';

// yeoman:inject:feature
import appConfig from './app.config.js';
import appRoute from './app.route.js';
import appRun from './app.run.js';
/**
 * This is the application module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace Application Module
 */
angular.module('app', [
  // Shared modules.
  core,
  // Feature areas.
  login,
  logout,
  errorpage,
  infopage,
  account,
  forgotten,
  memword,
  termscond,
  establishMemword,
  registration,
  twofactor,
  securityquestion,
  changepassword,
  changeforgottenpassword
  // yeoman:inject:feature
])
  // Register config.
  .config(appConfig)
  // Register route.
  .config(appRoute)
  // Register directive
  .directive('autofocus', autofocus)
  .directive('clickOrEnter', clickOrEnter)
  .directive('myOnLoad', myOnLoad)
  // Register global values (these can be overriden for each product)
  .value('useEmailLogin', false)
  .value('deviceprintFnBmo', null)
  .value('deviceprintFn', null)
  .value('whitelabel', null)
  // Register run.
  .run(appRun);

export default 'app';



// WEBPACK FOOTER //
// ./src/app.module.js